export default (currentTitle, projectsCount) => currentTitle ? currentTitle : 'New Project'



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/offlineProjectTitle.js